import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const AgencyPeopleIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 20 21"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <path d="M15.616 5.044a1.617 1.617 0 0 0-1.46.7.75.75 0 1 1-1.237-.848 3.116 3.116 0 0 1 5.682 2 3.117 3.117 0 0 1-3.347 2.87.75.75 0 1 1 .115-1.496 1.617 1.617 0 1 0 .247-3.226Z"/>
        <path clipRule="evenodd"
            d="M10 5.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM8.25 9a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0ZM10 12.75c-1.366 0-2.69.481-3.68 1.361-.993.882-1.57 2.099-1.57 3.389a.75.75 0 0 0 .75.75h9a.75.75 0 0 0 .75-.75c0-1.29-.577-2.507-1.57-3.389-.99-.88-2.314-1.361-3.68-1.361Zm-2.684 2.482c.699-.62 1.663-.982 2.684-.982 1.021 0 1.985.361 2.684.982.484.43.81.957.964 1.518H6.352c.154-.56.48-1.088.964-1.518Z"/>
        <path d="M5.843 5.744a1.616 1.616 0 0 0-2.948 1.037c.068.89.846 1.557 1.736 1.489a.75.75 0 1 1 .115 1.495A3.117 3.117 0 1 1 7.08 4.896a.75.75 0 1 1-1.238.848ZM14.729 11.194a.75.75 0 0 1 .75-.75 4.301 4.301 0 0 1 4.301 4.3v1.184a.75.75 0 0 1-.75.75h-2.184a.75.75 0 0 1 0-1.5h1.434v-.433a2.8 2.8 0 0 0-2.801-2.801.75.75 0 0 1-.75-.75ZM4.551 10.444a.75.75 0 0 1 0 1.5 2.801 2.801 0 0 0-2.801 2.8v.434h1.434a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1-.75-.75v-1.183a4.301 4.301 0 0 1 4.301-4.301Z"/>
    </svg>
);
AgencyPeopleIcon.displayName = 'AgencyPeopleIcon';
export default AgencyPeopleIcon;
